import { FormGroup, Input, Label } from "reactstrap";
import { useBjelinTranslations } from "../../../hooks/TranslationHooks";
import PropTypes from "prop-types";

const NewsletterField = ({ newsletter, callback }) => {
  const t = useBjelinTranslations();
  const onChange = () => callback(!newsletter);
  return (
    <FormGroup>
      <FormGroup check>
        <Label check>
          <Input type={"checkbox"} checked={newsletter} onChange={onChange} />
          {" " + t("subscribe.to.newsletter")}
        </Label>
      </FormGroup>
    </FormGroup>
  );
};

NewsletterField.propTypes = {
  newsletter: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired
};

export default NewsletterField;
